import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import { APP_DATE_FORMAT } from '../../config/app_config';
import { checkInstallAdmin, renderDisabledStatus, renderEnabledStatus } from '../../utils/common';

const LIST_BUILDING = 'LIST_BUILDING';

export default class InstallListItem extends React.Component {
  static propTypes = {
    install: PropTypes.object.isRequired,
  };

  getSortedTags = availableTags =>
    availableTags && availableTags.size > 0
      ? availableTags.sortBy(tag =>
          tag.get('tagDescription') ? tag.get('tagDescription') : tag.get('tagValue')
        )
      : null;

  groupTagsByDescription = tags => {
    const group = {};
    tags.forEach(tag => {
      (group[tag.get('tagDescription')] = group[tag.get('tagDescription')] || []).push(tag);
    });
    return group;
  };

  renderAvailableTags = (tag, index, groupedTags, shownGroups) => {
    const { install } = this.props;
    const installId = install.installation.get('id');
    const groupedTag = groupedTags[tag.get('tagDescription')];
    const encodedTag = encodeURIComponent(JSON.stringify(groupedTag));

    // So we only show each group once...
    if (shownGroups.has(groupedTag)) {
      return null;
    }

    shownGroups.set(groupedTag, true);
    return (
      <Link
        key={index}
        to={`/search/${installId}/${encodedTag}`}
        className="btn btn-primary"
        style={{ marginLeft: '0.5rem', marginBottom: '0.375rem' }}
      >
        {!tag.get('tagDescription') ? tag.get('tagValue') : tag.get('tagDescription')}
      </Link>
    );
  };

  render() {
    const { install } = this.props;
    const { installation, installationUser, useCases } = install;
    const status = installation.get('installStatus');
    const installId = installation.get('id');
    const availableTags = this.getSortedTags(install.availableTags);
    const isAdmin = checkInstallAdmin(installationUser.get('permissions'));
    const name = installation.get('description');
    const lastUpdate = moment(installation.get('updatedOn')).format(APP_DATE_FORMAT);
    const useCaseCodes = useCases.valueSeq().map(useCase => useCase.code);
    const isProspectingEnabled = useCaseCodes.indexOf(LIST_BUILDING) !== -1;
    const groupedTags = availableTags ? this.groupTagsByDescription(availableTags) : null;
    const shownGroups = new Map();

    return (
      <div className="container container-home">
        <div className="row">
          <div className="col-sm-12">
            <span className="pull-right">
              Status:{' '}
              <i>{status === 'INSTALLED' ? renderEnabledStatus() : renderDisabledStatus()}</i>
            </span>
            <h4>{name}</h4>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-3">
            <p>Last updated {lastUpdate}</p>
          </div>
          <div className="col-sm-12 col-md-9">
            <span className="pull-right">
              {isAdmin ? (
                <Link
                  to={`/admin/configure-install/${installId}`}
                  className="btn btn-default btn-md"
                  style={{ marginLeft: '0.5rem' }}
                >
                  Admin
                </Link>
              ) : null}
              {isProspectingEnabled ? (
                <span>
                  {status === 'INSTALLED' && !availableTags ? (
                    <Link
                      to={`/search/${installId}`}
                      className="btn btn-primary"
                      style={{ marginLeft: '0.5rem' }}
                    >
                      Prospecting Search
                    </Link>
                  ) : null}
                  {status === 'INSTALLED' && availableTags && availableTags.size <= 2 ? (
                    <span>
                      <strong style={{ marginLeft: '0.75rem' }}>Prospect For:</strong>{' '}
                      {availableTags.map((tag, idx) =>
                        this.renderAvailableTags(tag, idx, groupedTags, shownGroups)
                      )}
                    </span>
                  ) : null}
                </span>
              ) : null}
            </span>
          </div>
        </div>
        {status === 'INSTALLED' && availableTags && availableTags.size > 2 ? (
          <div className="row">
            <div className="col-sm-12">
              <h5>Prospect For:</h5>
              {availableTags.map((tag, idx) =>
                this.renderAvailableTags(tag, idx, groupedTags, shownGroups)
              )}
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
